import { createSlice } from "@reduxjs/toolkit";
import { AppDispatch } from "configureStore";

interface UserBusinessTripsState {
  refreshNonce: number;
}

const initialState: UserBusinessTripsState = {
  refreshNonce: 0,
};

const UserBusinessTripsSlice = createSlice({
  name: "userBusinessTrips",
  initialState,
  reducers: {
    setDestroy() {
      return initialState;
    },
    requestBusinessTripsRefresh(state: UserBusinessTripsState) {
      state.refreshNonce += 1;
    },
  },
});

const { actions, reducer } = UserBusinessTripsSlice;

export const { setDestroy, requestBusinessTripsRefresh } = actions;
export default reducer;

/** Backward-compatible alias used after create/edit business trip. */
export const fetchUserBusinessTripsThunk =
  (_companyId?: string, _filtersValue?: unknown) =>
  (dispatch: AppDispatch) => {
    dispatch(requestBusinessTripsRefresh());
  };
